// extracted by mini-css-extract-plugin
module.exports = {"titleItem":"infoItem_titleItem__1JDOe","infoItem":"infoItem_infoItem__258Jk","titleItemText":"infoItem_titleItemText__d9Km-"};